<template>
  <v-dialog v-model="createDeductionShow" persistent max-width="390">
    <v-card class="pa-6">
      <v-form ref="form">
        <v-row class="ma-0">
          <v-col cols=8 class="pa-0 pr-1">
            <v-combobox
              v-model="localDeduction.type"
              :items="deductionTypesSplit"
              :rules="requiredRules"
              label="评分类型"
            ></v-combobox>
          </v-col>
          <v-col class="pa-0">
            <v-select
              v-model="localDeduction.type_order"
              :items="deductionTypesOrder"
              :rules="requiredRules"
              label="评分类型序号"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="ma=0 ml-0">
          <v-radio-group
            v-model="localDeduction.mark"
            row
            :rules="requiredRules"
            active-class="primary--text"
          >
            <v-radio
              v-for="(type, index) in deductionMarks"
              :key="index"
              :label="type.text"
              :value="type.value"
              :color="type.value === 'right'
                ? 'green'
                : type.value === 'half_error'
                    ? 'orange'
                    : 'red'"
            ></v-radio>
          </v-radio-group>
          <v-btn
            class="mt-4"
            dark
            small
            :color="localDeduction.color"
            @click.stop="toggleColorPicker"
          >
            自定义颜色
          </v-btn>
        </v-row>
        <v-row class="ma-0">
          <v-radio-group
            v-if="
              user.role !== 'centreadmin' &&
              config.enableEditingPublic &&
              config.enableEditingPrivate"
            v-model="localDeduction.pub_status"
            class="ma-0"
            row
            :rules="requiredRules"
            active-class="primary--text"
          >
            <v-radio
              v-for="(type, index) in deductionStatus"
              :key="index"
              :label="type.text"
              :value="type.value"
              :color="type.value === 'public' ? 'primary' : 'secondary'"
            ></v-radio>
          </v-radio-group>
        </v-row>
        <v-row class="ma-0">
          <v-textarea
            v-model="localDeduction.description"
            :rules="requiredRules"
            auto-grow
            label="请输入给学生的评语"
            rows="3"
            counter
            maxlength="100"
          ></v-textarea>
        </v-row>
        <v-row class="ma-0">
          <v-checkbox
            v-model="localDeduction.hide_comment"
            label="批改时隐藏给学生的评语"
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-row>
        <v-row class="ma-0">
          <v-textarea
            v-model="localDeduction.notes"
            auto-grow
            label="仅教师可见的解释"
            rows="3"
            counter
            maxlength="200"
          ></v-textarea>
        </v-row>
        <v-row class="ma-0">
          <v-col v-if="localDeduction.mark !== 'right'" class="pa-0">
            <v-text-field
              v-model="point"
              :rules="notRightNumberRules"
              ref="minus"
              type="number"
              min="-100"
              max="0"
              label="扣分值"
            ></v-text-field>
          </v-col>
          <v-col v-else class="pa-0">
            <v-text-field
              v-model="point"
              ref="plus"
              :rules="rightNumberRules"
              type="number"
              min="0"
              max="100"
              label="加分值"
            ></v-text-field>
          </v-col>
          <v-col cols=1 class="pa-0 mt-5 mr-4 ml-1">
            <v-btn
              dark
              x-small
              color="pink"
              @click.stop="add(point)"
            >
              <v-icon dark>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-col>
          <v-col cols=3 class="pa-0">
            <v-text-field
              v-model="localDeduction.order"
              :rules="orderRules"
              type="number"
              min="1"
              max="100"
              label="评分序号"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col
            v-for="(score, index) in localDeduction.scores"
            :key=index
            class="pa-0"
            cols=2
          >
            <v-chip
              :value="score"
              small
              close
              @click:close="remove(score)"
            >
              {{ score }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row v-if="showScoresMessage" class="ma-0">
          <span
            style="color: #ff5252; font-size: 12px;"
          >
            至少添加一个分值
          </span>
        </v-row>
        <v-row class="ma-0">
          <v-checkbox
            v-model="localDeduction.hide_score"
            label="批改时隐藏分值"
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-row>
        <v-row v-if="!localDeduction.isCommon" class="ma-0">
          <v-select
            v-model="localDeduction.experiment"
            :items="experiments"
            :rules="experimentRules"
            item-text="name"
            item-value="code"
            label="实验"
          ></v-select>
        </v-row>
        <v-row v-if="allowPublicDeductionPoint" class="pl-2">
          <v-checkbox
            v-model="localDeduction.isCommon"
            class="ma-0 pa-0"
            label="所有实验都可用"
            required
          ></v-checkbox>
        </v-row>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            color="green darken-1"
            text
            :disabled="pendingConfirm"
            @click="close"
            >取消</v-btn
          >
          <v-btn color="primary" :disabled="pendingConfirm" @click="save">
            确认
            <v-progress-circular
              v-if="pendingConfirm"
              indeterminate
              color="red"
              size="20"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <color-picker
      v-if="showColorPicker"
      :deductionColor="localDeduction.color"
      position="relative"
      :top="-855"
      :topOffset="293"
      :right="-319"
      :rightOffset="301"
      @pickColor="setColor"
    ></color-picker>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import ColorPicker from './ColorPicker';

export default {
  data() {
    return {
      requiredRules: [value => !!value || '必填.'],
      rightNumberRules: [
        value => (value >= 0 && value <= 100) || '分值范围：0 ~ 100',
        value => !this.localDeduction.scores.some(item => item == value) || '分值已存在'
      ],
      notRightNumberRules: [
        value => (value >= -100 && value <= 0) || '分值范围：-100 ~ 0',
        value => !this.localDeduction.scores.some(item => item == value) || '分值已存在'
      ],
      orderRules: [
        value => !!value || '必填.',
        value => (value >= 1 && value <= 100) || '序号范围：1 ~ 100'
      ],
      experimentRules: [
        value => !!value || '必填.',
        value => value !== '' || '评分类型不能未空值'
      ],
      localDeduction: {},
      deductionTypesOrder: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      point: null,
      scoresMessage: '',
      showScoresMessage: false,
      showColorPicker: false
    };
  },
  components: { ColorPicker },
  mounted() {
    this.fetchDeductionMarks();
    this.fetchDeductionStatus();
  },
  computed: {
    ...mapGetters([
      'config',
      'user',
      'createDeductionShow',
      'allowPublicDeductionPoint',
      'deductionTypes',
      'deduction',
      'deductionMarks',
      'deductionStatus',
      'deductions',
      'experiment',
      'experiments',
      'pendingConfirm',
      'confirmAction'
    ]),
    deductionTypesSplit() {
      return this.deductionTypes.map(item => {
        return item.split('.')[1];
      });
    }
  },
  watch: {
    deduction(val) {
      this.localDeduction = JSON.parse(JSON.stringify(val));
    },
    'localDeduction.mark': {
      handler(val) {
        if (
          this.deduction.mark === 'right' && val !== 'right'
          || this.deduction.mark !== 'right' && val === 'right'
        ) this.clear();
      },
      deep: true
    },
    'localDeduction.type': function(val) {
      if (val && this.deductionTypesSplit.some(item => item === val)) {
        let order = this.deductionTypes.find(item => {
          return item.split('.')[1] === val;
        }).split('.')[0];

        this.localDeduction.type_order = parseInt(order);
        this.deductionTypesOrder = [parseInt(order)];
      } else {
        this.localDeduction.type_order = 1;
        this.deductionTypesOrder = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchDeductionMarks',
      'fetchDeductionStatus',
      'addDeduction',
      'updateDeduction',
      'alert'
    ]),
    add(point) {
      if (
        this.localDeduction.mark === 'right' && !this.$refs.plus.validate()
      ) return;

      if (
        this.localDeduction.mark !== 'right' && !this.$refs.minus.validate()
      ) return;

      if (point) {
        this.localDeduction.scores.push(parseFloat(point));
        this.point = null;
        this.scoresMessage = '';
        this.showScoresMessage = false;
      }
    },
    setColor(color) {
      if (color === 'close') this.showColorPicker = false;
      else this.localDeduction.color = color;
    },
    remove(point) {
      this.localDeduction.scores
        .splice(this.localDeduction.scores.findIndex(item => item == point), 1);
    },
    clear() {
      this.point = null;
      this.localDeduction.scores = [];
    },
    save() {
      if (this.point !== null) this.add(this.point);

      if (!this.localDeduction.scores.length) {
        this.showScoresMessage = true;

        return;
      }

      if (!this.$refs.form.validate()) return;

      if(this.localDeduction.type.trim() === '') {
        this.alert({ message: '评分类型不能为空值', color: 'error' });
      }

      if (
        this.user.role === 'centreadmin' ||
        this.config.enableEditingPublic && !this.config.enableEditingPrivate
      ) {
        this.localDeduction.pub_status = 'public';
      } else if (!this.config.enableEditingPublic && this.config.enableEditingPrivate) {
        this.localDeduction.pub_status = 'private';
      }

      if (this.localDeduction.id) {
        this.updateDeduction(this.localDeduction).then(() => {
          this.$store.commit('setDeductionShow', false);
        });
      } else {
        let exist = this.deductions.some(item => {
          return item[1].some(d => {
            if (
              d.comment === this.localDeduction.description &&
              d.experiment === this.localDeduction.experiment &&
              d.type === this.localDeduction.type
            ) {
              this.alert({
                message: '同一实验无法创建描述相同的标签',
                color: 'error'
              });
              return true;
            }
          });
        });

        if (exist) {
          return;
        }

        this.addDeduction(this.localDeduction).then(() => {
          this.$store.commit('setDeductionShow', false);
        });
      }

      this.showColorPicker = false;
    },
    close() {
      this.clear();
      this.$store.commit('setDeductionShow', !this.createDeductionShow);
      this.showColorPicker = false;
    },
    toggleColorPicker() {
      this.showColorPicker = !this.showColorPicker;
    },
  }
};
</script>
